import { render } from "./VMultiSelectJQ.vue?vue&type=template&id=082f9b2f"
import script from "./VMultiSelectJQ.vue?vue&type=script&lang=js"
export * from "./VMultiSelectJQ.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__